module.exports = __webpack_public_path__ + "img/pencil.365bb6da.svg";